import { render } from "./PhotosComponent.vue?vue&type=template&id=039239a0"
import script from "./PhotosComponent.vue?vue&type=script&lang=js"
export * from "./PhotosComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__